export default "__VITE_ASSET__bBw4AARL__"